/* Triumph DATA PLATE | tl-compare.js (CS area)
   Compare tray for the search page (REF pg-search compare: up to 3 picks in a sticky tray, then a
   modal dialog with a side-by-side table). Product data comes from the product-card Compare
   toggles: button[data-tl-compare=<handle>] with data-title, data-url, data-image, data-vendor,
   data-type, data-price, data-sku, data-capacity. The picks persist in localStorage ('tl-compare';
   every access wrapped in try/catch, so a blocked storage just means no persistence) and sync
   across tabs. Markup (sections/main-search.liquid): [data-tl-compare-tray] with
   [data-tl-compare-status], [data-tl-compare-list], [data-tl-compare-open], [data-tl-compare-clear];
   dialog[data-tl-compare-dialog] with [data-tl-compare-table] and [data-tl-compare-close].
   Re-syncs card buttons on 'tl:facets:updated' and re-initialises on shopify:section:load. */
(function () {
  'use strict';

  var TL = window.TL || (window.TL = {});
  var KEY = 'tl-compare';
  var MAX = 3;
  var trays = [];
  var items = load();

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function str(v) { return typeof v === 'string' ? v : ''; }
  function safeUrl(u) { u = str(u); return /^\/(?!\/)[^\s"'<>]*$/.test(u) ? u : ''; }
  function safeImg(u) { u = str(u); return (/^(https:)?\/\/[^\s"'<>]+$/.test(u) || /^\/(?!\/)[^\s"'<>]*$/.test(u)) ? u : ''; }
  function clean(it) {
    if (!it || typeof it !== 'object') return null;
    var o = {
      handle: str(it.handle), title: str(it.title), url: safeUrl(it.url), image: safeImg(it.image),
      vendor: str(it.vendor), type: str(it.type), price: str(it.price), capacity: str(it.capacity), sku: str(it.sku)
    };
    return o.handle && o.title && o.url ? o : null;
  }
  function load() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      var out = [];
      list.forEach(function (it) { var c = clean(it); if (c && out.length < MAX && indexIn(out, c.handle) < 0) out.push(c); });
      return out;
    } catch (e) { return []; }
  }
  function save() {
    try { window.localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) { /* storage blocked: keep in memory */ }
  }
  function indexIn(list, handle) {
    for (var i = 0; i < list.length; i++) if (list[i].handle === handle) return i;
    return -1;
  }
  function fromButton(btn) {
    var d = btn.dataset;
    return clean({
      handle: d.tlCompare, title: d.title, url: d.url, image: d.image, vendor: d.vendor,
      type: d.type, price: d.price, capacity: d.capacity, sku: d.sku
    });
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function photo(it, size) {
    if (it.image) {
      var img = el('img');
      img.src = it.image;
      img.alt = '';
      img.width = size;
      img.height = size;
      if (size > 48) img.loading = 'lazy';
      img.decoding = 'async';
      return img;
    }
    var span = el('span', 'tl-qnp');
    span.setAttribute('aria-hidden', 'true');
    return span;
  }
  function focusEl(n) { if (!n) return; try { n.focus({ preventScroll: false }); } catch (e) { n.focus(); } }

  /* ── one tray per search section ─────────────────────────────────────── */
  function Tray(node) {
    this.node = node;
    this.root = node.closest('[data-tl-facets-root]') || node.parentNode;
    this.status = $('[data-tl-compare-status]', node);
    this.list = $('[data-tl-compare-list]', node);
    this.openBtn = $('[data-tl-compare-open]', node);
    this.dialog = $('[data-tl-compare-dialog]', this.root);
    this.table = this.dialog ? $('[data-tl-compare-table]', this.dialog) : null;
    this.message = '';
    var self = this;
    this.onClick = function (e) { self.click(e); };
    this.onClose = function () { self.afterClose(); };
    this.onDialogClick = function (e) { if (e.target === self.dialog) self.closeDialog(); };
    this.onDialogKey = function (e) { if ((e.key === 'Escape' || e.key === 'Esc') && self.dialog && !self.dialog.showModal) self.closeDialog(); };
    this.onCloseBtn = function () { self.closeDialog(); };
    this.closeBtn = this.dialog ? $('[data-tl-compare-close]', this.dialog) : null;
    node.addEventListener('click', this.onClick);
    if (this.closeBtn) this.closeBtn.addEventListener('click', this.onCloseBtn);
    if (this.dialog) {
      this.dialog.addEventListener('close', this.onClose);
      this.dialog.addEventListener('click', this.onDialogClick);
      this.dialog.addEventListener('keydown', this.onDialogKey);
    }
    this.render();
  }

  Tray.prototype.destroy = function () {
    this.node.removeEventListener('click', this.onClick);
    if (this.closeBtn) this.closeBtn.removeEventListener('click', this.onCloseBtn);
    if (this.dialog) {
      this.dialog.removeEventListener('close', this.onClose);
      this.dialog.removeEventListener('click', this.onDialogClick);
      this.dialog.removeEventListener('keydown', this.onDialogKey);
      if (this.dialog.open) { try { this.dialog.close(); } catch (e) { this.dialog.removeAttribute('open'); } }
    }
    delete this.node.dataset.tlInit;
  };

  Tray.prototype.render = function () {
    var n = items.length;
    var self = this;
    this.node.hidden = n === 0;
    if (this.root && this.root.classList) this.root.classList.toggle('has-compare', n > 0);
    if (this.status) this.status.textContent = this.message || (n + ' of ' + MAX + ' selected');
    this.message = '';
    if (this.openBtn) this.openBtn.disabled = n < 2;
    if (this.list) {
      this.list.textContent = '';
      items.forEach(function (it) {
        var li = el('li');
        li.appendChild(photo(it, 48));
        li.appendChild(el('span', 'tl-qtl__t', it.title));
        var rm = el('button', 'tl-qrm');
        rm.type = 'button';
        rm.setAttribute('data-tl-compare-remove', it.handle);
        rm.appendChild(el('span', 'tl-sr', 'Remove ' + it.title));
        li.appendChild(rm);
        self.list.appendChild(li);
      });
    }
    syncButtons();
  };

  Tray.prototype.click = function (e) {
    var t = e.target.closest ? e.target.closest('button') : null;
    if (!t || !this.node.contains(t)) return;
    if (t.hasAttribute('data-tl-compare-remove')) {
      var handle = t.getAttribute('data-tl-compare-remove');
      var i = indexIn(items, handle);
      if (i > -1) items.splice(i, 1);
      commit();
      var next = $('[data-tl-compare-remove]', this.list);
      focusEl(next || cardButton(handle) || $('[data-tl-compare]', this.root) || $('.tl-qin', this.root));
    } else if (t.hasAttribute('data-tl-compare-clear')) {
      items = [];
      commit();
      focusEl($('[data-tl-compare]', this.root) || $('.tl-qin', this.root));
    } else if (t.hasAttribute('data-tl-compare-open')) {
      this.openDialog();
    }
  };

  Tray.prototype.openDialog = function () {
    if (!this.dialog || !this.table || items.length < 2) return;
    this.buildTable();
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
      if (typeof TL.trapFocus === 'function') TL.trapFocus(this.dialog);
    }
    if (typeof TL.lockScroll === 'function') { TL.lockScroll(true); this.locked = true; }
    focusEl(this.closeBtn);
  };

  Tray.prototype.closeDialog = function () {
    if (!this.dialog) return;
    if (typeof this.dialog.close === 'function' && this.dialog.open) this.dialog.close();
    else { this.dialog.removeAttribute('open'); this.afterClose(); }
  };

  Tray.prototype.afterClose = function () {
    if (this.locked && typeof TL.lockScroll === 'function') { TL.lockScroll(false); this.locked = false; }
    if (typeof this.dialog.showModal !== 'function' && typeof TL.removeTrapFocus === 'function') TL.removeTrapFocus();
    focusEl(this.openBtn);
  };

  Tray.prototype.buildTable = function () {
    var table = el('table');
    if (items.length > 2) table.className = 'is-3';
    var caption = el('caption', 'tl-sr', 'Side-by-side comparison of ' + items.length + ' products');
    table.appendChild(caption);
    var hasCap = items.some(function (it) { return it.capacity; });
    var hasSku = items.some(function (it) { return it.sku; });
    var rows = [
      ['Product', function (it) { var th = el('th', null, it.title); th.scope = 'col'; return th; }],
      ['Photo', function (it) { var td = el('td'); td.appendChild(photo(it, 200)); return td; }],
      ['Brand', function (it) { return el('td', null, it.vendor || '—'); }],
      ['Type', function (it) { return el('td', null, it.type || '—'); }]
    ];
    if (hasCap) rows.push(['Capacity', function (it) { return el('td', null, it.capacity || '—'); }]);
    rows.push(['Price', function (it) {
      var td = el('td', 'tl-qdt__price');
      var p = it.price || '—';
      var m = /^(From)\s+(.*)$/.exec(p);
      if (m) { td.appendChild(el('small', null, m[1])); td.appendChild(document.createTextNode(m[2])); } else td.textContent = p;
      return td;
    }]);
    if (hasSku) rows.push(['SKU', function (it) { return el('td', null, it.sku || '—'); }]);
    rows.push(['', function (it) {
      var td = el('td');
      var a = el('a', 'tl-btn tl-btn--sm', 'View');
      a.href = it.url;
      a.appendChild(el('span', 'tl-sr', ' ' + it.title));
      td.appendChild(a);
      return td;
    }]);
    rows.forEach(function (row) {
      var tr = el('tr');
      var th = el('th', null, row[0]);
      th.scope = 'row';
      if (!row[0]) th.appendChild(el('span', 'tl-sr', 'Link'));
      tr.appendChild(th);
      items.forEach(function (it) { tr.appendChild(row[1](it)); });
      table.appendChild(tr);
    });
    this.table.textContent = '';
    this.table.appendChild(table);
  };

  /* ── shared state ────────────────────────────────────────────────────── */
  function cardButton(handle) {
    var all = $$('[data-tl-compare]');
    for (var i = 0; i < all.length; i++) if (all[i].getAttribute('data-tl-compare') === handle) return all[i];
    return null;
  }
  function syncButtons() {
    $$('[data-tl-compare]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', indexIn(items, btn.getAttribute('data-tl-compare')) > -1 ? 'true' : 'false');
    });
  }
  function commit(message) {
    save();
    trays.forEach(function (t) { if (message) t.message = message; t.render(); });
  }
  function toggle(btn) {
    var it = fromButton(btn);
    if (!it) return;
    var i = indexIn(items, it.handle);
    if (i > -1) {
      items.splice(i, 1);
      commit();
    } else if (items.length >= MAX) {
      commit('Max ' + MAX + '. Remove one first.');
      return;
    } else {
      items.push(it);
      commit();
    }
    try { btn.scrollIntoView({ block: 'nearest' }); } catch (e) { /* ignore */ }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-tl-compare]') : null;
    if (!btn || !trays.length) return;
    e.preventDefault();
    toggle(btn);
  });
  document.addEventListener('tl:facets:updated', syncButtons);
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    items = load();
    trays.forEach(function (t) { t.render(); });
  });

  function init(scope) {
    $$('[data-tl-compare-tray]', scope || document).forEach(function (node) {
      if (node.dataset.tlInit) return;
      node.dataset.tlInit = '1';
      trays.push(new Tray(node));
    });
  }
  function destroy(scope) {
    trays = trays.filter(function (t) {
      if (scope.contains(t.node)) { t.destroy(); return false; }
      return true;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });

  TL.compare = {
    items: function () { return items.slice(); },
    clear: function () { items = []; commit(); }
  };
})();
